<template>
  <div class="auth-layout">
    <!-- Left Column — EXACTO del login -->
    <div class="auth-left">
      <div class="auth-left__logo">
        <img
          :src="myDesskWhite"
          alt="mydessk"
          style="height: 28px; width: auto"
        />
      </div>

      <div class="auth-left__content">
        <h1 class="auth-left__headline">
          Deja de trabajar<br />a ciegas.<br /><span
            class="auth-left__headline--accent"
            >Tu negocio tiene<br />que crecer.</span
          >
        </h1>

        <div class="auth-left__illustration">
          <svg
            viewBox="0 0 260 148"
            fill="none"
            class="auth-left__illustration-svg"
          >
            <rect
              x="0"
              y="18"
              width="108"
              height="130"
              rx="10"
              fill="rgba(255,255,255,0.05)"
              stroke="rgba(255,255,255,0.1)"
              stroke-width="0.8"
            />
            <rect
              x="10"
              y="30"
              width="52"
              height="5"
              rx="2.5"
              fill="rgba(255,255,255,0.15)"
            />
            <rect
              x="10"
              y="40"
              width="32"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="10"
              y="53"
              width="88"
              height="0.7"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="10"
              y="61"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.1)"
            />
            <rect
              x="58"
              y="61"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.06)"
            />
            <rect
              x="10"
              y="70"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.1)"
            />
            <rect
              x="58"
              y="70"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.06)"
            />
            <rect
              x="10"
              y="79"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.1)"
            />
            <rect
              x="58"
              y="79"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.06)"
            />
            <rect
              x="10"
              y="93"
              width="88"
              height="0.7"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="54"
              y="100"
              width="44"
              height="6"
              rx="2"
              fill="rgba(62,207,180,0.25)"
            />
            <rect
              x="56"
              y="102"
              width="40"
              height="2.5"
              rx="1.25"
              fill="#3ecfb4"
              opacity="0.7"
            />
            <rect
              x="10"
              y="114"
              width="88"
              height="7"
              rx="3.5"
              fill="rgba(62,207,180,0.15)"
              stroke="rgba(62,207,180,0.3)"
              stroke-width="0.6"
            />
            <rect
              x="28"
              y="116.5"
              width="48"
              height="2"
              rx="1"
              fill="rgba(62,207,180,0.5)"
            />
            <rect
              x="118"
              y="0"
              width="142"
              height="88"
              rx="10"
              fill="rgba(255,255,255,0.05)"
              stroke="rgba(255,255,255,0.1)"
              stroke-width="0.8"
            />
            <rect
              x="130"
              y="12"
              width="48"
              height="4.5"
              rx="2.25"
              fill="rgba(255,255,255,0.15)"
            />
            <rect
              x="130"
              y="21"
              width="28"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.07)"
            />
            <rect
              x="130"
              y="33"
              width="13"
              height="28"
              rx="3"
              fill="rgba(83,74,183,0.5)"
            />
            <rect
              x="149"
              y="43"
              width="13"
              height="18"
              rx="3"
              fill="rgba(62,207,180,0.4)"
            />
            <rect
              x="168"
              y="37"
              width="13"
              height="24"
              rx="3"
              fill="rgba(83,74,183,0.35)"
            />
            <rect
              x="187"
              y="29"
              width="13"
              height="32"
              rx="3"
              fill="rgba(62,207,180,0.55)"
            />
            <rect
              x="206"
              y="49"
              width="13"
              height="12"
              rx="3"
              fill="rgba(83,74,183,0.3)"
            />
            <rect
              x="130"
              y="65"
              width="94"
              height="0.6"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="130"
              y="71"
              width="48"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="118"
              y="98"
              width="142"
              height="50"
              rx="10"
              fill="rgba(255,255,255,0.05)"
              stroke="rgba(255,255,255,0.1)"
              stroke-width="0.8"
            />
            <circle cx="136" cy="114" r="8" fill="rgba(62,207,180,0.2)" />
            <circle cx="136" cy="114" r="4" fill="rgba(62,207,180,0.6)" />
            <rect
              x="150"
              y="109"
              width="40"
              height="4"
              rx="2"
              fill="rgba(255,255,255,0.15)"
            />
            <rect
              x="150"
              y="117"
              width="24"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.07)"
            />
            <circle cx="136" cy="134" r="8" fill="rgba(186,117,23,0.2)" />
            <circle cx="136" cy="134" r="4" fill="rgba(186,117,23,0.6)" />
            <rect
              x="150"
              y="129"
              width="30"
              height="4"
              rx="2"
              fill="rgba(255,255,255,0.12)"
            />
            <rect
              x="150"
              y="137"
              width="20"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.06)"
            />
          </svg>
        </div>

        <div class="auth-left__stat">
          <div class="auth-left__stat-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M3 17V8l7-5 7 5v9"
                stroke="#3ecfb4"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <rect
                x="7.5"
                y="11"
                width="5"
                height="6"
                rx="1"
                fill="rgba(62,207,180,0.3)"
                stroke="#3ecfb4"
                stroke-width="1.2"
              />
            </svg>
          </div>
          <div>
            <span class="auth-left__stat-number">+200</span>
            <span class="auth-left__stat-label">comercios registrados</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="auth-right">
      <div class="auth-right__container">
        <h2 class="auth-right__title">Recuperar contraseña</h2>
        <p class="auth-right__subtitle">
          Ingresa tu correo electrónico y te enviaremos las instrucciones para
          restablecer tu contraseña.
        </p>

        <!-- Success message -->
        <div v-if="isResponseAlert" class="recovery-alert">
          <div class="recovery-alert__icon">
            <i class="el-icon-circle-check"></i>
          </div>
          <div>
            <p class="recovery-alert__text">
              {{ recoveryPasswordResponse }}
            </p>
            <router-link :to="{ name: 'login' }" class="recovery-alert__link">
              Ir a iniciar sesión
            </router-link>
          </div>
        </div>

        <!-- Form -->
        <el-form
          v-if="!isResponseAlert"
          :model="formRecovery"
          :rules="rules"
          ref="formRecovery"
          @submit.native.prevent="onSubmit"
        >
          <el-form-item prop="email">
            <label class="auth-label">Correo electrónico</label>
            <el-input
              v-model="formRecovery.email"
              placeholder="tu@correo.com"
              autocomplete="on"
              name="email"
            ></el-input>
          </el-form-item>

          <button
            class="auth-submit-btn"
            type="submit"
            @click.prevent="onSubmit"
          >
            Enviar instrucciones
          </button>
        </el-form>

        <div class="recovery-back">
          <router-link :to="{ name: 'login' }" class="recovery-back__link">
            <i class="el-icon-arrow-left"></i>
            Volver a iniciar sesión
          </router-link>
        </div>
      </div>

      <div class="auth-mobile-logo">
        <img
          :src="myDesskBlack"
          alt="mydessk"
          style="height: 30px; width: auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Validate from "@/assets/validate";
import { myDesskWhite, myDesskBlack } from "@/services/resources";
import AuthServices from "../../services/AuthServices";

export default {
  name: "RecoveryPasswordPage",
  data: () => ({
    myDesskWhite,
    myDesskBlack,
    formRecovery: {
      email: ""
    },
    rules: {
      email: [{ ...Validate.rules.required(), ...Validate.rules.email() }]
    },
    isResponseAlert: false,
    recoveryPasswordResponse: ""
  }),
  methods: {
    onSubmit() {
      this.$refs.formRecovery.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          this.isResponseAlert = false;
          try {
            let response = await AuthServices.passwordRecovery(
              this.formRecovery
            ).finally(() => {
              this.$store.dispatch("toggleRequestLoading");
            });

            if (response) {
              this.recoveryPasswordResponse = response.data.message;
              this.isResponseAlert = true;
            }
          } catch (error) {
            this.$notifications.error({
              message: "Ha ocurrido un imprevisto, por favor intenta de nuevo"
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../Login/Login.scss";

.recovery-alert {
  background: #e4fff4;
  border: 1px solid #c8f0e0;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
}
.recovery-alert__icon {
  color: #1d9e75;
  font-size: 22px;
  flex-shrink: 0;
  margin-top: 2px;
}
.recovery-alert__text {
  margin: 0 0 8px 0;
  color: #31355c;
  font-size: 14px;
  line-height: 1.5;
}
.recovery-alert__link {
  color: #1d9e75;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.recovery-back {
  text-align: center;
  margin-top: 24px;
}
.recovery-back__link {
  color: #909399;
  font-size: 14px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.15s;
  &:hover {
    color: #31355c;
  }
  i {
    font-size: 12px;
  }
}
</style>
